import { render, staticRenderFns } from "./TradingHome.vue?vue&type=template&id=1f200a6b&scoped=true&"
import script from "./TradingHome.vue?vue&type=script&lang=js&"
export * from "./TradingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f200a6b",
  null
  
)

export default component.exports